module.exports = __webpack_public_path__ + "static/media/Lizard Man.588bfd27.jpg";